import { useQuery } from 'react-query';

import { getProvinceList } from '../api/getProvinceList';
import { masterDataKeys, masterDataStaleTime } from '../api/queryKeys';

export const useProvinceList = (params, { enabled = true } = {}) => {
  const { data, isLoading, isError, refetch } = useQuery(
    masterDataKeys.provinces(params),
    () => getProvinceList(params),
    {
      enabled,
      staleTime: masterDataStaleTime.BATCH,
      keepPreviousData: true,
    }
  );

  return { data, isLoading, isError, refetch };
};

export default useProvinceList;
